import { render, staticRenderFns } from "./Download-Layout.vue?vue&type=template&id=52f109af&"
import script from "./Download-Layout.vue?vue&type=script&lang=js&"
export * from "./Download-Layout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports